import OpenAccessIcon from 'public/icons/interface/tag-open-access.svg'
import PreviewIcon from 'public/icons/interface/tag-preview.svg'

const TAG_VARIANTS = {
  default: {
    className: 'tag tag--default',
    showDot: false,
    defaultLabel: 'Tag label',
  },
  new: {
    className: 'tag tag--new',
    showDot: true,
    defaultLabel: 'Nowość',
  },
  'open-access': {
    className: 'tag tag--open-access',
    showDot: false,
    icon: OpenAccessIcon,
    defaultLabel: 'Open Access',
  },
  preview: {
    className: 'tag tag--preview',
    showDot: false,
    icon: PreviewIcon,
    defaultLabel: 'Zapowiedź',
  },
}

export default function Tag({ type = 'default', label, className = '', showDot, ...props }) {
  const variantKey = TAG_VARIANTS[type] ? type : 'default'
  const variant = TAG_VARIANTS[variantKey]
  const shouldShowDot = showDot ?? variant.showDot
  const Icon = variant.icon
  const tagLabel = label ?? variant.defaultLabel
  const combinedClassName = `${variant.className} ${className}`.trim()

  return (
    <span className={combinedClassName} {...props}>
      {shouldShowDot && <span className="tag__dot" aria-hidden="true" />}
      {Icon && <Icon className="tag__icon" aria-hidden="true" />}
      <span>{tagLabel}</span>
    </span>
  )
}
